<template>
  <el-dialog
    class="order-info-dialog order-paper"
    @close="onClose"
    :top="isMobile ? '0' : '20vh'"
    :close-on-click-modal="true"
    :show-close="true"
    :class="{ mobile_dialog: isMobile, order: process === 'pay' }"
    :width="!isMobile ? (currentLang === 1 ? '500px' : '460px') : '100vw'"
    height="350px"
    :visible.sync="dialogVisible"
    center
    append-to-body
  >
    <div class="work-info" v-if="process === 'ordering' && !isMobile">
      <div class="cover">
        <img :src="goodsObj.cover" />
      </div>
      <div class="info">
        <div class="title">付费订阅<br />{{ goodsObj.worksName }}</div>
        <div class="order-type">
          <el-radio v-model="orderType" :label="0">购买本期报纸</el-radio><br />
          <el-radio v-if="orderDateOption.length > 0" v-model="orderType" :label="1">订报纸</el-radio>
          <!-- <el-radio :value="2" v-model="orderType" label="办会员"></el-radio>-->
          <div class="time-option" v-if="orderType === 1">
            <span>时长：</span>
            <el-select style="width: 150px" v-model="orderDate" placeholder="请选择订阅时间" size="mini">
              <el-option v-for="(item, index) in orderDateOption" :key="index" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <div class="date-range">刊期：{{ dataRange }}</div>
          </div>
        </div>
        <div class="detail">
          <div class="item">
            <span>订阅价格：&nbsp;&nbsp;</span>
            <span class="red" style="font-size: 20px">￥{{ price }}</span>
          </div>
          <div class="item" style="color: #A6A6A6;margin-top: 10px">
            <span>{{ orderType === 2 ? '*可在会员期内阅读所有报纸' : '*可永久阅读购买的报纸' }}</span>
          </div>
        </div>
      </div>
      <div class="button" :class="{ en: currentLang === 1 }">
        <el-button @click="orderGoods">{{ languageOption.subscribeNow }}</el-button>
        <el-button @click="collect">{{ languageOption.addToFavorites }}</el-button>
      </div>
    </div>
    <div class="work-info work-info__mobile" v-if="process === 'ordering' && isMobile">
      <div class="cover">
        <img :src="goodsObj.cover" />
        <img src="@imgs/toolbar/pay-tip_ordering.png" style="height: 39px;width: auto;position: absolute;right: 10px;bottom: 0" />
      </div>
      <div class="info">
        <div class="title">{{ goodsObj.worksName }}</div>
        <div class="order-type" v-show="mobileStep === 1">
          <el-radio-group v-model="orderType">
            <el-radio-button class="step-1" :label="0">购买本期报纸</el-radio-button>
            <el-radio-button v-if="orderDateOption.length > 0" class="step-1" :label="1">订报纸</el-radio-button>
          </el-radio-group>
          <div class="item" style="color: #A6A6A6;margin-top: 10px;text-align: center">
            <span>{{ orderType === 2 ? '*可在会员期内阅读所有报纸' : '*可永久阅读购买的报纸' }}</span>
          </div>
        </div>
        <div class="order-type" v-show="mobileStep === 2 && orderType === 1">
          <el-radio-group v-model="orderDate" style="width: 300px">
            <el-radio-button class="step-2" v-for="(item, index) in orderDateOption" :key="index" :label="item.value">{{ item.label }}</el-radio-button>
          </el-radio-group>
        </div>
        <div class="detail" v-show="mobileStep === 2">
          <div class="item">
            <span>刊期：</span>
            <span>{{ dataRange }}</span>
          </div>
          <div class="item">
            <span>订阅价格：&nbsp;&nbsp;</span>
            <span class="red" style="font-size: 18px">￥{{ price }}</span>
          </div>
        </div>
      </div>
      <div class="button step" v-show="mobileStep === 1">
        <el-button @click="mobileStep++">下一步</el-button>
        <el-button @click="collect">先加收藏</el-button>
      </div>
      <div class="button step" v-show="mobileStep === 2">
        <el-button @click="orderGoods">确定</el-button>
        <el-button @click="mobileStep--">返回</el-button>
      </div>
    </div>
    <div class="order-info" v-if="process === 'pay'">
      <div class="goods">
        <div class="cover">
          <img :src="goodsObj.cover" />
          <img v-if="isMobile" src="@imgs/toolbar/pay-tip_pay.png" style="height: 39px;width: auto;position: absolute;right: 10px;bottom: 0" />
        </div>
        <div class="title-wrapper">
          <div class="title" v-if="!isMobile">{{ languageOption.welcomeToSubscribe }}</div>
          <div class="title">{{ goodsObj.worksName }}</div>
          <div style="color: #383838;font-size: 14px;">刊期：{{ dataRange }}</div>
        </div>
      </div>
      <div class="order">
        <span>{{ languageOption.orderNumber }}：{{ order.orderSn }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <span>
          {{ languageOption.orderPrice }}：<i class="red">{{ order.totalAmount }}</i>
        </span>
      </div>
      <div class="pay-option">
        <span>{{ !isMobile ? languageOption.paymentTip : '支付方式' }}：</span>
        <el-radio v-model="payWay" :label="2">
          <img src="@imgs/toolbar/wechatPay-icon.png" />
        </el-radio>
        <el-radio v-model="payWay" :label="1" v-show="!isMobile">
          <img src="@imgs/aplipay_vip.png" />
        </el-radio>
      </div>
      <!--<div v-if="!isMobile" class="note">*选择支付宝支付，请通过浏览器打开进行支付。</div>-->
      <div class="button">
        <el-button @click="goPay">{{ languageOption.goToPayment }}</el-button>
      </div>
    </div>
    <div class="processing" v-if="process === 'paying' && !isMobile">
      <div class="title">{{ payWay === 1 ? (currentLang === 1 ? 'Alipay' : '支付宝支付') : currentLang === 1 ? 'WeChat Pay' : '微信支付' }}</div>
      <vue-qr :text="qrCodeUrl" :size="88" :margin="5" />
      <p>{{ currentLang === 1 ? 'Please scan the QR code on your mobile phone for payment' : '请手机扫描二维码支付' }}</p>
    </div>
    <div class="processing" v-if="process === 'paying' && isMobile">
      <p>{{ currentLang === 1 ? 'Please wait a moment' : '支付确认中，请稍等片刻。' }}</p>
      <img src="@imgs/toolbar/loading.gif" />
    </div>
    <div class="processing" v-if="process === 'payed'">
      <p>{{ currentLang === 1 ? 'Thank you for your subscription' : '订单完成，感谢您的订阅。' }}</p>
      <div class="button">
        <el-button @click="reload">{{ currentLang === 1 ? 'Start Reading' : '开始阅读' }}</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import chargeApi from '@api/chargeManager'
import { isLogin, getQuarterRange } from '@/utils'
import user from '@api/login'
import VueQr from 'vue-qr'
import moment from 'moment'
export default {
  name: 'BaozhiOrderDialog',
  data() {
    return {
      dialogVisible: false,
      process: 'ordering',
      payWay: 2,
      order: {},
      qrCodeUrl: '',
      statusTimer: null,
      orderType: 0,
      orderDate: '',
      orderDateOption: [],
      mobileStep: 1,
      goodsObj: { ...this.$store.state.common.goodsObj }
    }
  },
  props: {
    type: {
      default: 'book',
      type: String
    },
    articleId: {
      default: ''
    },
    ebookId: {
      default: ''
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.process = 'ordering'
      }
    }
  },
  components: { VueQr },
  computed: {
    showClose() {
      return this.goodsObj.chargePage > 0 && (!this.isMobile || (this.isMobile && (this.process === 'pay' || this.process === 'ordering')))
    },
    isMobile() {
      return this.$store.state.book.isMobile
    },
    issueDate() {
      return this.$store.state.config.bookObj.issueDate
    },
    publishDate() {
      return this.$store.state.book.bookData.publishDate
    },
    userName() {
      return localStorage.getItem('username')
    },
    languageOption() {
      return this.$store.state.config.languageOptions[this.currentLang]
    },
    currentLang() {
      const type = this.type === 'article' ? 'book' : this.type
      return this.$store.state.config[type + 'Obj'].language
    },
    price() {
      if (this.orderType === 1) {
        switch (this.orderDate) {
          case 'month':
            return this.goodsObj.issuePrice.mPrice
          case 'quarter':
            return this.goodsObj.issuePrice.qPrice
          case 'half':
            return this.goodsObj.issuePrice.hPrice
          case 'year':
            return this.goodsObj.issuePrice.yPrice
        }
      }
      return this.goodsObj.price
    },
    dataRange() {
      if (this.orderType === 0) {
        return moment(this.publishDate).format('YYYY年M月D日')
      } else if (this.orderType === 1) {
        let current = new Date(this.publishDate)
        let fullYear = current.getFullYear()
        let month = current.getMonth() + 1
        switch (this.orderDate) {
          case 'month':
            let endData = new Date(fullYear, month, 0).getDate()
            return fullYear + '年' + month + '月' + '1日-' + fullYear + '年' + month + '月' + endData + '日'
          case 'quarter':
            return getQuarterRange(current)
          case 'half':
            return month < 7 ? fullYear + '年1月1日-' + fullYear + '年6月30日' : fullYear + '年7月1日-' + fullYear + '年12月31日'
          case 'year':
            return fullYear + '年1月1日-' + fullYear + '年12月31日'
        }
      }
      return ''
    }
  },
  methods: {
    async orderGoods() {
      if (this.orderType === 1 && !this.orderDate) {
        this.$message({
          message: '请选择订阅刊期',
          type: 'error'
        })
        return
      }
      await isLogin()
      let param = {
        userName: localStorage.getItem('username'),
        worksId: this.goodsObj.worksId,
        worksType: 'cloud_read_baozhi_' + (this.orderType === 0 ? 'single' : this.orderDate),
        issueDate: this.issueDate
      }
      let orderApi = chargeApi.addBaoZhiOrder
      orderApi(param).then((res) => {
        let data = res.data.data
        if (data) {
          this.order = data.order
          this.order.name = data.orderItemList[0].productName
          this.process = 'pay'
        } else {
          this.$message({
            message: res.data.message || '创建订单失败',
            type: 'error'
          })
        }
      })
      if (this.isMobile) {
        this.payWay = 2
      }
    },
    collect() {
      this.$emit('collect', 'order')
    },
    goPay() {
      if (!this.payWay || this.payWay === '') {
        this.$message({
          message: this.languageOption.paymentTip,
          type: 'error'
        })
        return
      }
      let param = {
        orderCode: this.order.orderSn,
        payID: this.payWay
      }
      const accessCode = this.$route.query.accessCode || localStorage.getItem('accessCode')
      if (!this.isMobile) {
        chargeApi.getPayQRCode(param).then((res) => {
          if (res.data.status === 0) {
            this.qrCodeUrl = res.data.data.qrCodeUrl
            this.process = 'paying'
            this.statusTimer = setInterval(this.getPayStatus, 2000)
          } else {
            this.$message({
              message: '请求失败，请刷新重试',
              type: 'error'
            })
          }
        })
      } else {
        if (accessCode && accessCode !== '') {
          this.qizhiPay(accessCode)
        } else {
          let ua = window.navigator.userAgent.toLowerCase()
          let isWx = ua.match(/MicroMessenger/i) == 'micromessenger'
          if (isWx) {
            //微信浏览器付费接口
            param.openId = localStorage.getItem('openId')
            if (!param.openId) {
              window.location.href = window.PROJECT_CONFIG.BASE_URL + '/fxsso/login?service=' + window.encodeURIComponent(window.location.href)
              return
            }
            let _this = this
            chargeApi.wxJSAPIPay(param).then((res) => {
              if (res.data.status === 0 && res.data.data) {
                let jsApiSetting = res.data.data.jsapiResut
                if (typeof WeixinJSBridge == 'undefined') {
                  if (document.addEventListener) {
                    document.addEventListener('WeixinJSBridgeReady', _this.onBridgeReady(jsApiSetting), false)
                  } else if (document.attachEvent) {
                    document.attachEvent('WeixinJSBridgeReady', _this.onBridgeReady(jsApiSetting))
                    document.attachEvent('onWeixinJSBridgeReady', _this.onBridgeReady(jsApiSetting))
                  }
                } else {
                  this.onBridgeReady(jsApiSetting)
                }
                this.process = 'paying'
                this.statusTimer = setInterval(this.getPayStatus, 2000)
              } else {
                this.$message({
                  message: '请求失败，请刷新重试',
                  type: 'error'
                })
              }
            })
          } else {
            chargeApi.wxH5Pay(param).then((res) => {
              if (res.data.status === 0) {
                if (res.data.data) {
                  let a = document.createElement('a')
                  a.setAttribute('href', res.data.data.h5Result)
                  a.target = '_blank'
                  a.click()
                  a.remove()
                }
                this.process = 'paying'
                this.statusTimer = setInterval(this.getPayStatus, 2000)
              } else {
                this.$message({
                  message: '请求失败，请刷新重试',
                  type: 'error'
                })
              }
            })
          }
        }
      }
    },
    onBridgeReady(jsApiSetting) {
      WeixinJSBridge.invoke('getBrandWCPayRequest', jsApiSetting, function(res) {
        if (res.err_msg == 'get_brand_wcpay_request:ok') {
          this.process = 'payed'
          clearInterval(this.statusTimer)
        } else {
          this.$message({
            message: '支付失败，请刷新重试',
            type: 'error'
          })
        }
      })
    },
    getPayStatus() {
      let param = {
        orderCode: this.order.orderSn,
        payID: this.payWay
      }
      chargeApi.queryOrderStatus(param).then((res) => {
        if (res.data.status === 0) {
          this.process = 'payed'
          clearInterval(this.statusTimer)
        }
      })
    },
    async qizhiPay(accessCode) {
      if (window.$bridge) {
        let phone = localStorage.getItem('qizhiPhone')
        if (!phone || phone == 'null') {
          await user.getQizhiUserInfo(accessCode).then((res) => {
            if (res.data.status === 0 && res.data.data) {
              phone = res.data.data.phone
            }
          })
        }
        window.$bridge.callhandler(
          'weixinPay',
          {
            orderNo: this.order.orderSn,
            orderAmount: this.goodsObj.price,
            productName: this.order.name,
            paymentMethod: this.payWay,
            mobile: phone
          },
          (response) => {
            alert('桥接成功')
            alert('桥接返回值：' + response.data + response.status)
            if (response.status === 'success') {
              this.qizhiOrderPayAuth(response.data)
            } else {
              alert('支付失败')
            }
          }
        )
      } else {
        alert('桥接失败')
      }
    },
    qizhiOrderPayAuth(data) {
      chargeApi
        .qizhiOrderPayAuth({
          orderCode: this.order.orderSn,
          payStatus: 1,
          accessCode: this.$route.query.accessCode,
          qiZhiPhone: localStorage.getItem('qizhiPhone')
        })
        .then((res) => {
          alert('qizhiOrderPayAuth接口返回值：' + res.data.status)
          if (res.data.status === 0) {
            this.process = 'payed'
            this.$store.commit('common/UPDATE_IS_ORDERED', true)
          }
        })
    },
    reload() {
      this.dialogVisible = false
      window.location.reload()
    },
    onClose() {
      this.$emit('close')
      this.$store.commit('book/UPDATE_ORDER_DIALOG_VISIBLE', false)
    }
  },
  mounted() {
    if (this.goodsObj.issuePrice) {
      const orderMapping = {
        month: 0,
        quarter: 1,
        half: 2,
        year: 3
      }
      for (const issue in this.goodsObj.issuePrice) {
        let label = ''
        let value = ''
        switch (issue) {
          case 'mPrice':
            label = '一个月'
            value = 'month'
            break
          case 'yPrice':
            label = '一年'
            value = 'year'
            break
          case 'qPrice':
            label = '三个月'
            value = 'quarter'
            break
          case 'hPrice':
            label = '半年'
            value = 'half'
            break
        }
        this.orderDateOption.push({ label: label, value: value })
      }
      // 按照指定顺序排序
      this.orderDateOption.sort((a, b) => orderMapping[a.value] - orderMapping[b.value])
    }
  },
  destroyed() {
    clearInterval(this.statusTimer)
  }
}
</script>

<style scoped lang="scss">
.order-paper {
  .work-info {
    height: 260px;
    .cover {
      margin-top: 0;
      img {
        height: 100%;
        width: auto;
      }
      .button {
        margin-top: 20px;
      }
    }
    .info {
      width: 240px;
      .order-type {
        .el-radio {
          margin-bottom: 10px;
        }
      }
    }
    .detail {
      position: absolute;
      bottom: 20px;
    }
    .button {
      position: absolute;
      left: 25px;
      bottom: 20px;
      width: 158px;
      .el-button {
        &:last-child {
          background-color: #999999;
        }
      }
      &.en {
        .el-button {
          margin-left: 0;
        }
      }
    }
    &__mobile {
      flex-direction: column;
      .cover {
        width: 100%;
        margin-top: -100px !important;
        padding-left: 10px;
        height: 200px;
        position: relative;
      }
      .info {
        width: 100%;
        .title {
          width: 100%;
          -webkit-line-clamp: 1;
          margin: 10px 0;
          text-align: center;
        }
        .order-type {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 100%;
        }
        .detail {
          position: relative;
          bottom: 0;
          .item {
            margin-top: 10px;
          }
        }
      }
      .button.step {
        width: 100%;
        left: 0;
        .el-button {
          width: 100px;
          &:last-child {
            background-color: #999999;
          }
        }
      }
    }
  }
  .title {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    width: 300px;
    margin-bottom: 10px;
  }
  .date-range {
    white-space: nowrap;
    margin-top: 10px;
  }
  .cover {
    pointer-events: none;
  }
  .order-info {
    .goods {
      .cover {
        img {
          height: 100%;
          width: auto;
        }
      }
    }
  }
  .cover {
    img {
      max-width: 100%;
    }
  }
  &.mobile_dialog {
    .order-info {
      font-size: 16px;
      .goods {
        flex-direction: column;
        .cover {
          width: 100%;
          margin-top: -100px !important;
          padding-left: 10px;
          height: 200px;
          position: relative;
        }
        .title {
          margin: 10px 0 5px;
          font-size: 16px;
          line-height: 30px;
        }
      }
      .title {
        width: 100%;
        text-align: center;
      }
      .order {
        font-size: 16px;
        margin-top: 20px;
      }
    }
    .cover {
      :first-child {
        box-shadow: 0px 0px 10px;
      }
    }
  }
  .processing {
    .title {
      width: 100%;
    }
  }
}
</style>
<style lang="scss">
.order-paper {
  .el-dialog__header {
    background-color: #fff;
  }
  .el-dialog__body {
    padding-top: 0 !important;
  }
  &.mobile_dialog {
    .el-dialog__header {
      background-color: unset;
    }
    .el-dialog {
      height: 400px;
      border-radius: 40px 40px 0 0;
    }
  }
  .el-radio-button {
    margin-bottom: 10px;
    .el-radio-button__inner {
      border: 1px solid #dcdfe6 !important;
      border-radius: 20px !important;
    }
    &.step-1 {
      width: 250px;
      display: block;
      .el-radio-button__inner {
        width: 250px;
      }
    }
    &.step-2 {
      width: 120px;
      margin: 0 15px 10px 15px;
      .el-radio-button__inner {
        width: 120px;
      }
    }
    .el-radio-button__orig-radio:checked + .el-radio-button__inner {
      background-color: #e5e5e5;
      border: none;
      color: #383838;
      box-shadow: none;
    }
  }
}
</style>
